export const UPLOADED_ITEM_ID = 'uploaded_item_id'
export const UPLOAD_SESSION_ID = 'upload_session_id'
export const UPLOADED_ITEM_PROMOTIONS = 'uploaded_item_promotions'
export const MODEL_UNKNOWN_ID = 1
export const MODEL_OTHER_ID = 2
export const MODEL_SEARCH_MAX_LENGTH = 100
export const MODEL_SUGGESTION_MIN_LENGTH = 1
export const MODEL_SUGGESTION_MAX_LENGTH = 100
